<button (click)="open()">
    
        <div class="hero__image" style="background-image: url(assets/img/temp/hero-img.png);"></div><!-- /.hero__image -->

        <p class="hero__play js-play"  target="_blank">
            <img src="assets/img/svg/ico-play.svg" alt="">
        </p>
   <!-- /.hero__media -->
</button>
